import { render, staticRenderFns } from "./SidebarHeaderTitle.vue?vue&type=template&id=15adc373&"
import script from "./SidebarHeaderTitle.vue?vue&type=script&lang=js&"
export * from "./SidebarHeaderTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports